import { getInputValue } from '../../shared/dom.util';
import {
    MATERIAL_SUMMARY_DESTINATION_FACILITY_ELEMENT_ID,
    MATERIAL_SUMMARY_FROM_DATE_ELEMENT_ID,
    MATERIAL_SUMMARY_INPUT_MATERIAL_TYPE_ID_ELEMENT_ID,
    MATERIAL_SUMMARY_MATERIAL_TYPE_NAME_ELEMENT_ID,
    MATERIAL_SUMMARY_ORIGIN_FACILITY_ELEMENT_ID,
    MATERIAL_SUMMARY_REPORT_ALIAS_ELEMENT_ID,
    MATERIAL_SUMMARY_REPORT_DATE_ELEMENT_ID,
    MATERIAL_SUMMARY_TO_DATE_ELEMENT_ID,
    resolveMaterialSummaryRecordCount,
} from '../constants/material-summary.constants';
import { REPORT_RECORD_COUNT_ELEMENT_ID } from '../../agreements/report-record-count.constants';
import type { MaterialSummaryTaskPaneFilterRead } from './build-material-summary-payload.util';
import { localCalendarDateOnlyToday } from './local-calendar-date-only-today.util';

/**
 * Reads Material Summary filter fields from the task pane DOM (when that target is selected).
 */
export function readMaterialSummaryTaskPaneFilterFromDom(): MaterialSummaryTaskPaneFilterRead {
    const recordCountRaw = getInputValue(REPORT_RECORD_COUNT_ELEMENT_ID);
    const parsedRc = Number.parseInt(recordCountRaw, 10);
    const recordCount = resolveMaterialSummaryRecordCount(
        Number.isNaN(parsedRc) ? undefined : parsedRc
    );

    const dateSingle = getInputValue(MATERIAL_SUMMARY_REPORT_DATE_ELEMENT_ID).trim() || undefined;
    const fromDate = getInputValue(MATERIAL_SUMMARY_FROM_DATE_ELEMENT_ID).trim() || undefined;
    let toDate = getInputValue(MATERIAL_SUMMARY_TO_DATE_ELEMENT_ID).trim() || undefined;
    if (fromDate === undefined) {
        // UI may default "to" to today; only send a range when "from" is set.
        toDate = undefined;
    } else if (toDate === undefined) {
        toDate = localCalendarDateOnlyToday();
    }

    const read: MaterialSummaryTaskPaneFilterRead = {
        recordType: getInputValue('filter-record-type').trim() || undefined,
        recordCount,
        date: dateSingle,
        fromDate,
        toDate,
        originFacilityCode:
            getInputValue(MATERIAL_SUMMARY_ORIGIN_FACILITY_ELEMENT_ID).trim() || undefined,
        destinationFacilityCode:
            getInputValue(MATERIAL_SUMMARY_DESTINATION_FACILITY_ELEMENT_ID).trim() || undefined,
        materialTypeName:
            getInputValue(MATERIAL_SUMMARY_MATERIAL_TYPE_NAME_ELEMENT_ID).trim() || undefined,
        inputMaterialTypeId:
            getInputValue(MATERIAL_SUMMARY_INPUT_MATERIAL_TYPE_ID_ELEMENT_ID).trim() || undefined,
        reportAlias: getInputValue(MATERIAL_SUMMARY_REPORT_ALIAS_ELEMENT_ID).trim() || undefined,
    };

    return read;
}
